var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgDocument = function SvgDocument(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "278F46A7-32C7-4DF6-9617-3A30EE2ADA55") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SUEZ-PCE_UI_Lot1_Desktop_newSDS",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "NEW_05_SUEZ-PCE_UI_client_05_accueil",
    transform: "translate(-646.000000, -338.000000)",
    fill: "#030F40"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(620.000000, 306.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Document",
    transform: "translate(26.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000, 4.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.96,8.75299927 C8.43564422,8.75242735 8.84587143,9.08696534 8.941,9.553 L8.941,9.553 L9.219,10.95 C9.31412857,11.4160347 9.72435578,11.7505727 10.2,11.75 L10.2,11.75 L22.499,11.75 C22.7988216,11.7498001 23.0829131,11.8841379 23.273,12.116 C23.4649129,12.3493967 23.5410004,12.6570549 23.48,12.953 C23.2811852,13.9470741 22.9809561,15.4485514 22.6670182,17.018499 L22.494947,17.8789862 C22.0927353,19.8903224 21.6941481,21.8832963 21.48,22.953 C21.3849463,23.4186663 20.9752686,23.7529993 20.5,23.7529993 L20.5,23.7529993 L4.101,23.7529993 C3.62535578,23.7535727 3.21512857,23.4190347 3.12,22.953 L3.12,22.953 L0.52,9.953 C0.459935453,9.65874505 0.535299272,9.35307499 0.725263765,9.12046541 C0.915228259,8.88785582 1.1996773,8.75299927 1.5,8.75299927 L1.5,8.75299927 Z M19.5,0.25 C20.6045695,0.25 21.5,1.1454305 21.5,2.25 L21.5,2.25 L21.5,9.75 C21.5,10.3022847 21.0522847,10.75 20.5,10.75 C19.9477153,10.75 19.5,10.3022847 19.5,9.75 L19.5,9.75 L19.5,2.75 C19.5,2.47385763 19.2761424,2.25 19,2.25 L19,2.25 L7,2.25 C6.72385763,2.25 6.5,2.47385763 6.5,2.75 L6.5,2.75 L6.5,6.75 C6.5,7.30228475 6.05228475,7.75 5.5,7.75 C4.94771525,7.75 4.5,7.30228475 4.5,6.75 L4.5,6.75 L4.5,2.25 C4.5,1.1454305 5.3954305,0.25 6.5,0.25 L6.5,0.25 Z",
    id: "icon-fill-color"
  }))))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDocument);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/document.3176ee2e39e054e417a8bd792f882d36.svg";